import { FC } from 'react';
import { Box, Typography } from '@mui/material';

export interface QcsToggleOption<T> {
  value: T;
  label: string;
}

interface Props<T> {
  options: QcsToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

export const QcsMinimalistToggle: FC<Props<any>> = ({ options, value, onChange }) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        bgcolor: 'action.hover',
        borderRadius: 2,
        p: '3px',
        width: 'fit-content',
      }}
    >
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <Box
            key={String(option.value)}
            onClick={() => onChange(option.value)}
            sx={{
              px: 2,
              py: 0.5,
              borderRadius: 1.5,
              cursor: 'pointer',
              userSelect: 'none',
              transition: 'all 0.2s ease',
              bgcolor: isActive ? 'background.paper' : 'transparent',
              boxShadow: isActive ? 1 : 0,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: isActive ? 600 : 400,
                color: isActive ? 'text.primary' : 'text.secondary',
                whiteSpace: 'nowrap',
              }}
            >
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
